import { render, staticRenderFns } from "./WebPartVideo.vue?vue&type=template&id=480fa31d&"
import script from "./WebPartVideo.vue?vue&type=script&lang=js&"
export * from "./WebPartVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports